// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-container {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline; }\n  .search-container .customInput {\n    padding-bottom: unset; }\n  .search-container .btn-custom {\n    margin: 0px 10px;\n    padding: 5px 15px;\n    width: 70px;\n    height: 50px; }\n  .search-container .btn-exit {\n    background-color: #027aff;\n    color: white; }\n", ""]);
// Exports
module.exports = exports;
